import { Controller } from "@hotwired/stimulus";
import { useDebounce } from "stimulus-use";

// Connects to data-controller="auto-submit"
export default class extends Controller {
  static targets = ["form", "search"];
  static debounces = [
    "submit",
    "reset",
    { name: "search", wait: 500 },
    { name: "textsubmit", wait: 1000 },
  ];

  connect() {
    useDebounce(this);

    // This ensures focus is not lost when page reloads
    if (this.hasSearchTarget && this.searchTarget.value.trim() !== "") {
      this.searchTarget.focus();
      this.searchTarget.setSelectionRange(
        this.searchTarget.value.length,
        this.searchTarget.value.length,
      );
    }
  }

  submit(event) {
    event.preventDefault();
    this.formTarget.requestSubmit();
  }

  reset(event) {
    event.preventDefault();
    this.formTarget.reset();
    this.formTarget.requestSubmit();
  }

  search(_event) {
    // This is the "auto submit". Temporarily disabled. For this to feel nice as a user, we need to enable the turbo form
    // feature, which is currently disabled. This will allow us to keep the input focused and do the submission in the
    // background.
    // this.submit(event);
  }

  textsubmit(event) {
    this.submit(event);
  }
}
